module.exports = __webpack_public_path__ + "static/media/lt.0f648929.svg";